// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1EbIb","ranges":"BmiRanges_ranges__1VLTB"};